import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["prefixCls", "className", "avatar", "title", "description", "cover", "extra", "style"];
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMountMergeState } from '@ant-design/pro-utils';
import { Avatar, ConfigProvider } from 'antd';
import classNames from 'classnames';
import { useContext, useEffect, useMemo } from 'react';
import CheckCardGroup, { CardLoading, CheckCardGroupConnext } from './Group';
import { useStyle } from './style';

var CheckCard = function CheckCard(props) {
  var _classNames;

  var _useMountMergeState = useMountMergeState(props.defaultChecked || false, {
    value: props.checked,
    onChange: props.onChange
  }),
      _useMountMergeState2 = _slicedToArray(_useMountMergeState, 2),
      stateChecked = _useMountMergeState2[0],
      setStateChecked = _useMountMergeState2[1];

  var checkcardGroup = useContext(CheckCardGroupConnext);

  var _useContext = useContext(ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var handleClick = function handleClick(e) {
    var _props$onClick, _checkcardGroup$toggl;

    props === null || props === void 0 ? void 0 : (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, e);
    var newChecked = !stateChecked;
    checkcardGroup === null || checkcardGroup === void 0 ? void 0 : (_checkcardGroup$toggl = checkcardGroup.toggleOption) === null || _checkcardGroup$toggl === void 0 ? void 0 : _checkcardGroup$toggl.call(checkcardGroup, {
      value: props.value
    });
    setStateChecked === null || setStateChecked === void 0 ? void 0 : setStateChecked(newChecked);
  }; // small => sm large => lg


  var getSizeCls = function getSizeCls(size) {
    if (size === 'large') return 'lg';
    if (size === 'small') return 'sm';
    return '';
  };

  useEffect(function () {
    var _checkcardGroup$regis;

    checkcardGroup === null || checkcardGroup === void 0 ? void 0 : (_checkcardGroup$regis = checkcardGroup.registerValue) === null || _checkcardGroup$regis === void 0 ? void 0 : _checkcardGroup$regis.call(checkcardGroup, props.value);
    return function () {
      var _checkcardGroup$cance;

      return checkcardGroup === null || checkcardGroup === void 0 ? void 0 : (_checkcardGroup$cance = checkcardGroup.cancelValue) === null || _checkcardGroup$cance === void 0 ? void 0 : _checkcardGroup$cance.call(checkcardGroup, props.value);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value]);
  /**
   * 头像自定义
   *
   * @param prefixCls
   * @param cover
   * @returns
   */

  var renderCover = function renderCover(prefixCls, cover) {
    return _jsx("div", {
      className: "".concat(prefixCls, "-cover"),
      children: typeof cover === 'string' ? _jsx("img", {
        src: cover,
        alt: "checkcard"
      }) : cover
    });
  };

  var customizePrefixCls = props.prefixCls,
      className = props.className,
      avatar = props.avatar,
      title = props.title,
      description = props.description,
      cover = props.cover,
      extra = props.extra,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      others = _objectWithoutProperties(props, _excluded);

  var checkCardProps = _objectSpread({}, others);

  var prefixCls = getPrefixCls('pro-checkcard', customizePrefixCls);

  var _useStyle = useStyle(prefixCls),
      wrapSSR = _useStyle.wrapSSR,
      hashId = _useStyle.hashId;

  checkCardProps.checked = stateChecked;
  var multiple = false;

  if (checkcardGroup) {
    var _checkcardGroup$value;

    // 受组控制模式
    checkCardProps.disabled = props.disabled || checkcardGroup.disabled;
    checkCardProps.loading = props.loading || checkcardGroup.loading;
    checkCardProps.bordered = props.bordered || checkcardGroup.bordered;
    multiple = checkcardGroup.multiple;
    var isChecked = checkcardGroup.multiple ? (_checkcardGroup$value = checkcardGroup.value) === null || _checkcardGroup$value === void 0 ? void 0 : _checkcardGroup$value.includes(props.value) : checkcardGroup.value === props.value; // loading时check为false

    checkCardProps.checked = checkCardProps.loading ? false : isChecked;
    checkCardProps.size = props.size || checkcardGroup.size;
  }

  var _checkCardProps$disab = checkCardProps.disabled,
      disabled = _checkCardProps$disab === void 0 ? false : _checkCardProps$disab,
      size = checkCardProps.size,
      cardLoading = checkCardProps.loading,
      _checkCardProps$borde = checkCardProps.bordered,
      bordered = _checkCardProps$borde === void 0 ? true : _checkCardProps$borde,
      checked = checkCardProps.checked;
  var sizeCls = getSizeCls(size);
  var classString = classNames(prefixCls, className, hashId, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-loading"), cardLoading), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-checked"), checked), _defineProperty(_classNames, "".concat(prefixCls, "-multiple"), multiple), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "hashId", hashId), _classNames));
  var metaDom = useMemo(function () {
    if (cardLoading) {
      return _jsx(CardLoading, {
        prefixCls: prefixCls || ''
      });
    }

    if (cover) {
      return renderCover(prefixCls || '', cover);
    }

    var avatarDom = avatar ? _jsx("div", {
      className: "".concat(prefixCls, "-avatar ").concat(hashId),
      children: typeof avatar === 'string' ? _jsx(Avatar, {
        size: 48,
        shape: "square",
        src: avatar
      }) : avatar
    }) : null;

    var headerDom = (title || extra) && _jsxs("div", {
      className: "".concat(prefixCls, "-header ").concat(hashId),
      children: [_jsx("div", {
        className: "".concat(prefixCls, "-title ").concat(hashId),
        children: title
      }), extra && _jsx("div", {
        className: "".concat(prefixCls, "-extra ").concat(hashId),
        children: extra
      })]
    });

    var descriptionDom = description ? _jsx("div", {
      className: "".concat(prefixCls, "-description ").concat(hashId),
      children: description
    }) : null;
    var metaClass = classNames("".concat(prefixCls, "-content"), hashId, _defineProperty({}, "".concat(prefixCls, "-avatar-header"), avatarDom && headerDom && !descriptionDom));
    return _jsxs("div", {
      className: metaClass,
      children: [avatarDom, headerDom || descriptionDom ? _jsxs("div", {
        className: "".concat(prefixCls, "-detail ").concat(hashId),
        children: [headerDom, descriptionDom]
      }) : null]
    });
  }, [avatar, cardLoading, cover, description, extra, hashId, prefixCls, title]);
  return wrapSSR(_jsx("div", {
    className: classString,
    style: style,
    onClick: function onClick(e) {
      if (!cardLoading && !disabled) {
        handleClick(e);
      }
    },
    children: metaDom
  }));
};

CheckCard.Group = CheckCardGroup;
export default CheckCard;